import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import "./PdfPage.css";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";
import COmpBiDirTest from "./FaultSecondPageChartsBidirRender_Bus";

const chunkArray = (array, chunkSize) => {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};

// export default function FaultFifthPart(props) {
const FaultFifthPart = forwardRef((props, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [ECUData, setECUData] = useState({});
  const [TempDataBMS, setTempDataBMS] = useState([]);
  const [dataMainBMS, setDataMainBMS] = useState([]);
  const [toCalculateFaultBMS, setToCalculateFaultBMS] = useState(0);
  const [single_nameBMS, setsingle_nameBMS] = useState([]);
  const [LineContainerBodyBD, setCssLineCont] = useState({ height: "auto" });
  const [critcal_duration_fifth, setCritcal_duration_fifth] = useState([]);

  const tableRefs = useRef([]);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/faultanalysis_bus",
        body: { filterdata: gloablfilter },
      },
      ecuFaultResponse
    );
  }, [gloablfilter]);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/vehicleLevalBusFault",
        body: { filterdata: gloablfilter, defaultNav: "BMS" },
      },
      responceBarData
    );
  }, [ECUData]);

  const ecuFaultResponse = (data) => {
    const ecuDict = {};
    data.forEach((item) => {
      const ecu = item.key.ECU;
      const vehicleCount = item.vehicle_count.value;
      ecuDict[ecu] = vehicleCount;
    });
    setECUData(ecuDict);
  };

  const responceBarData = (data) => {
    // setTempData(data)
    if (data.defaultNav === "BMS") {
      // setTempDataBMS([]);
      // setDataMainBMS([]);
      deno(data);
    }
  };

  const deno = async (data) => {
    if (data.defaultNav !== null && data.defaultNav === "BMS") {
      //   if (ECUData.hasOwnProperty(defaultNav)) {
      await setTempDataBMS(data.result);
      await setToCalculateFaultBMS(ECUData[data.defaultNav]);
      //   }
    }
  };

  useEffect(() => {
    if (toCalculateFaultBMS !== 0) {
      const data = TempDataBMS;
      let dataArray = [];
      let maleAdd = 0;
      let femaleAdd = toCalculateFaultBMS;
      data.forEach((obj1, index) => {
        maleAdd += obj1.duration.value;
      });
      setCritcal_duration_fifth(maleAdd);
      let single_name_array = [];
      data.forEach((obj1, index) => {
        let male = (obj1.duration.value / maleAdd) * 100;
        let female = (obj1.Total_vehicle_count.value / femaleAdd) * 100;
        dataArray.push({
          age: obj1.key.spnname.toUpperCase(),
          male: -male,
          female: female,
          orgLevalMale: obj1.duration.value.toFixed(0).toString(),
          orgLevalFemale: obj1.Total_vehicle_count.value.toString(),
          signal_nm: obj1.key.spnname,
          signal_desc: obj1.key.Description,
          signal_val: obj1.key.spnvalue.toString(),
        });
        single_name_array.push(obj1.key.spnname);
      });
      //   setsingle_nameBCS1(single_name_array);
      for (let i = 0; i < dataArray.length; i++) {
        let count = 0;
        for (let j = i + 1; j < dataArray.length; j++) {
          if (dataArray[i].age === dataArray[j].age) {
            dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
            count = 1;
          }
        }
        if (count) {
          dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
        }
      }
      dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
      setDataMainBMS(dataArray);
    }
  }, [toCalculateFaultBMS]);

  const chunks1 = chunkArray(dataMainBMS, 21);

  useImperativeHandle(ref, () => ({
    getDataForSlide: () => ({
      chunks1,
      tableRefs,
      ECUData,
      TempDataBMS,
      dataMainBMS,
      toCalculateFaultBMS,
      single_nameBMS,
      LineContainerBodyBD,
      critcal_duration_fifth,
    }),
  }));

  return (
    <div className="faultfirstpart">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>
      <div className="row mt-2">
        <div className="col-md-8">
          <span
            className="text-left"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#002060",
              paddingLeft: "30px",
            }}
          >
            Faults Observed in Field :{" "}
          </span>
          <span
            className="text-right"
            style={{ color: "#002060", fontSize: "12px" }}
          >
            {props.startdate} - {props.enddate}
          </span>
        </div>
      </div>

      <div className="row mt-3 ">
        <div className="col-md-1"></div>
        <div className="col-md-8">
          <div className="row" style={{ textAlign: "right" }} id={"bms_title"}>
            <div className="col-md-4 text-start">
              <button className="btn" style={{ backgroundColor: "#d0d4d5" }}>
                BMS
              </button>
            </div>
            <div className="col-md-8 text-end">
              <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                <dt className="red_bus"></dt>
                <dd>Time Duration (mins)</dd>
                <dt className="yellow_bus" style={{ marginLeft: "5px" }}></dt>
                <dd>Vehicle Count</dd>
              </dl>
            </div>
          </div>
          <div className="row pt-1">
            <div style={LineContainerBodyBD}>
              {isLoading ? (
                <ChartLoader />
              ) : dataMainBMS.length > 0 ? (
                chunks1.map((chunk, chunkIndex) => (
                  <div
                    ref={tableRefs}
                    key={chunkIndex}
                    className={`pdf-page ${
                      chunkIndex === 0 ? "" : "pdf-page-extra-padding"
                    }`}
                  >
                    <div style={{ minHeight: "730px" }}>
                      <COmpBiDirTest
                        dataMain={chunk}
                        // id={"BMS"}
                        id={`BMS-${chunkIndex}`}
                        gloablfilter={gloablfilter}
                        signal_name={single_nameBMS}
                      />
                    </div>
                  </div>
                ))
              ) : (
                <div id="faultfifth_no_data">
                  <NoData />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row bottomcontent pl-4" style={{ paddingTop: "0px" }}>
        <div className="col-md-3">
          <img
            src="../../../assets/img_Bus/Pdf_Page/footer.png"
            alt=""
            style={{ height: "70px", width: "200px" }}
          />
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-4">
          <p
            style={{
              fontSize: "11px",
              paddingTop: "60px",
              paddingLeft: "10px",
            }}
          >
            Copyright, Confidential, Tata Motors Limited
          </p>
        </div>
      </div>
    </div>
  );
});

export default FaultFifthPart;
